<template>
  <div id="resume-desired-location" class="mb-3 mt-3 text-center">
    <div class="size-18 fw-bold mb-3 pt-3">プロフィール（希望条件）</div>
  </div>
  <div class="col-12 bg-white-primary mx-auto">
    <Willingness />
    <Prefecture />
    <DesiredAnnualIncome />
    <Industry />
    <DesiredOccupation />
    <hr class="color-grey-primary opacity-100" />
    <UploadPdf
      id="editFileResume"
      accept=".docx, .xlsx, .pdf"
      class="row mx-4"
      title="履歴書"
      :file-name="resumeFileName"
      file-type="resume"
      @upload="uploadResume"
    />
    <hr class="color-grey-primary opacity-100 my-3" />
    <UploadPdf
      id="fileProfessionalResume"
      accept=".docx, .xlsx, .pdf"
      class="row mx-4"
      title="職務経歴書"
      :file-name="professionalResumeFileName"
      file-type="professional_resume"
      @upload="uploadProfessionalResume"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Willingness from './Willingness.vue';
import Prefecture from './Prefecture.vue';
import DesiredAnnualIncome from './DesiredAnnualIncome.vue';
import Industry from './Industry.vue';
import DesiredOccupation from './DesiredOccupation.vue';
import UploadPdf from './UploadPdf.vue';
import { useOptionalInformationStore } from '@/stores/resume-candidate/OptionalInformation.store';

const emit = defineEmits<{
  (e: 'uploadFile', file: File): void;
  (e: 'uploadFileProfessional', file: File): void;
}>();

const uploadResume = (file: File): void => {
  emit('uploadFile', file);
};

const uploadProfessionalResume = (file: File): void => {
  emit('uploadFileProfessional', file);
};

const useOptionalInformation = useOptionalInformationStore();

const resumeFileName = computed(() => {
  const resumeFile = useOptionalInformation.candidate_daxtra_jsons.find(
    (item) => item.file_type === 'resume'
  );
  return resumeFile ? truncatedFileName(String(resumeFile.name)) : '';
});

const professionalResumeFileName = computed(() => {
  const resumeFile = useOptionalInformation.candidate_daxtra_jsons.find(
    (item) => item.file_type === 'professional_resume'
  );
  return resumeFile ? truncatedFileName(String(resumeFile.name)) : '';
});

const truncatedFileName = (name: string): string => {
  if (name && name.length > 30) {
    return name.substring(0, 30) + '...';
  } else {
    return name;
  }
};
</script>
